import React, { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';

interface CardProps {
  title: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  action?: string;
  onActionClick?: () => void;
}

const Card: React.FC<CardProps> = ({ title, icon, children, action, onActionClick }) => {
  return (
    <div className="bg-slate-800 rounded-xl border border-slate-700/50 overflow-hidden relative">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700/50">
        <div className="flex items-center gap-2">
          {icon && <span>{icon}</span>}
          {typeof title === 'string' ? (
            <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wide">{title}</h3>
          ) : (
            <div className="text-sm font-semibold text-slate-300 uppercase tracking-wide">{title}</div>
          )}
        </div>
        {action && (
          <button
            onClick={onActionClick}
            className="text-xs text-teal-400 hover:text-teal-300 flex items-center gap-1 transition-colors"
          >
            {action} <ChevronRight size={14} />
          </button>
        )}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
};

export default Card;
